import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error_403',
  templateUrl: './error_403.component.html',
  styleUrls: ['./error_403.component.css']
})
export class Error_403Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
